// Moved from src/pos/components/products/PriceBadge.js
import React from "react";

export default function PriceBadge({ price }) {
    return (
        <span className="inline-block bg-primary text-white text-xs font-bold px-3 py-1 rounded-full shadow">
            {typeof price === 'number' ? price.toLocaleString('en-US', { style: 'currency', currency: 'PHP' }) : price}
        </span>
    );
}
